import script from "./ClientOnboardingOverlayNew.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientOnboardingOverlayNew.vue?vue&type=script&setup=true&lang=js"

import "./ClientOnboardingOverlayNew.vue?vue&type=style&index=0&id=7374a845&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7374a845"]])

export default __exports__